import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0aa17b78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = { class: "flex align-center" }
const _hoisted_3 = { style: {"white-space":"nowrap","font-weight":"500","font-size":"14px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"filter":"brightness(40%)"},
  src: "ico/arrow-down-white.svg"
}, null, -1))
const _hoisted_5 = { class: "menu" }
const _hoisted_6 = {
  key: 0,
  class: "flex grow w100 align-center"
}
const _hoisted_7 = { class: "flex col w100 g10" }
const _hoisted_8 = { class: "flex align-center grow" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "18",
  style: {"filter":"invert(0.3)"},
  src: "/ico/search.svg"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_11 = { class: "menu-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectorItem = _resolveComponent("SelectorItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle())),
      class: "dropdown flex justify-between align-center"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "heading", {}, undefined, true),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getTitle()), 1)
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.search)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("textarea", {
                  oninput: "this.value = this.value.replace(/\\n/g,'')",
                  ref: "searchInput",
                  style: {"resize":"none","width":"100%","height":"19px","overflow":"hidden"},
                  onKeyup: _cache[1] || (_cache[1] = (e) => _ctx.onSearchChange(e.target.value)),
                  class: "search-input",
                  type: "text"
                }, null, 544)
              ]),
              _hoisted_10
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.nullable)
          ? (_openBlock(), _createBlock(_component_SelectorItem, {
              key: 0,
              defaultTitle: _ctx.defaultTitle
            }, null, 8, ["defaultTitle"]))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ])
  ]))
}